const saveFile = (fileName: string, data: Array<BlobPart>, contentType: string) => {
  const file = new Blob(data, { type: contentType });

  const element = document.createElement('a');
  element.href = URL.createObjectURL(file);
  element.download = fileName;

  document.body?.appendChild(element);

  element.click();

  return file;
};

export const buildBlockExportFileName = (blockName?: string) => {
  const sanitizedBlockName = (blockName || 'Block').replace(/["*/:<>?\\|]/g, '-').trim();
  const exportDate = new Date().toLocaleDateString('en-GB', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  });

  return `${sanitizedBlockName} export - ${exportDate}.xlsx`;
};

export default saveFile;
